<div
  class="redeem-picker"
  [ngStyle]="
    styleService.getStyleRule(
      undefined,
      [data.tab?.configurations?.modal?.modalBackground],
      undefined
    )
  "
>
  <div class="header">
    <h3
      class="redeem-modal-title"
      [ngStyle]="
        styleService.getStyleRule(
          [data.tab?.configurations?.modal?.redeemModalTitle, null, 'heading4'],
          [data.tab?.configurations?.modal?.redeemModalTitle?.background],
          [data.tab?.configurations?.modal?.redeemModalTitle?.border]
        )
      "
    >
      {{
        data.tab?.configurations?.modal?.redeemModalTitleInput ||
          "What would you like to redeem for?"
          | conditionalUppercase
            : styleService.getUppercaseValue(
                data.tab?.configurations?.modal?.redeemModalTitle
              )
      }}
    </h3>

    <div *ngIf="data.tab?.configurations?.modal?.isCloseOnOffMode">
  <!-- <div class="ksk-modal-close" (click)="closeModal()"></div> -->
  <div
    class="ksk-modal-close-button"
    [ngStyle]="styleService.getCloseButtonStyles(data.tab?.configurations?.modal?.closeButton)"
    (click)="closeModal()"
  ></div>
</div>


  </div>

  <div
    class="tabs"
    *ngIf="
      tabs.length &&
      data.tab?.configurations?.modal?.isTabButtonsAllowed !== false
    "
  >
    <button
      *ngFor="let t of tabs"
      type="button"
      class="tab-btn"
      [class.active]="t.id === activeTab"
      (click)="setTab(t.id)"
      [ngStyle]="getTabButtonStyles()"
    >
      <span class="tab-text">
        {{
          t.label
            | conditionalUppercase
              : styleService.getUppercaseValue(
                  data.tab?.configurations?.modal?.tabButtonRedeemRisk?.text
                )
        }}
      </span>

      <span class="tab-count" *ngIf="t.count">({{ t.count }})</span>
    </button>
  </div>

  <div class="grid-wrap">
    <div
      class="page-grid"
      *ngIf="pages[pageIndex] as page"
      [class.center-row]="page.length > 0 && page.length <= 4"
    >
      <app-redemption-v2-option-card
        *ngFor="let opt of pages[pageIndex]; trackBy: trackById"
        [option]="opt"
        (pick)="select($event)"
        [tab]="data?.tab"
        [mainTemplate]="data?.mainTemplate"
      ></app-redemption-v2-option-card>

      <div class="empty" *ngIf="!pages[pageIndex]?.length">
        {{ noOptionsMessage }}
      </div>
    </div>

    <!-- <div class="picker-body"> -->
    <!-- Arrows -->
    <button
      class="nav nav-prev"
      type="button"
      *ngIf="pages.length > 1 && pageIndex > 0"
      [ngStyle]="getArrowStyles('prev')"
      (click)="prevPage()"
    ></button>

    <button
      class="nav nav-next"
      type="button"
      *ngIf="pages.length > 1 && pageIndex < pages.length - 1"
      [ngStyle]="getArrowStyles('next')"
      (click)="nextPage()"
    ></button>
    <!-- </div> -->
  </div>
</div>
